import { render } from "./confirmedAddress.vue?vue&type=template&id=39d69e7d"
import script from "./confirmedAddress.vue?vue&type=script&lang=js"
export * from "./confirmedAddress.vue?vue&type=script&lang=js"

import exportComponent from "/data/jenkins/workspace/vas-web-client-pre/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])